import { Roles } from './enums/roles.enum';
import { SidebarOption } from './enums/sidebar-option.enum';
import PaymentsLinear from '../assets/img/sidebar/payments-linear.svg';
import SettingsSvg from '../assets/img/settings.svg';
import {
  MANAGE_SUBSCRIPTION,
  MY_GEM_FAV_ROUTE,
  MY_GEM_VAULT_ROUTE,
  PAYMENTS_ROUTE,
  POROLIS_GEM_BANK_ROUTE,
  SETTINGS_ROUTE,
  SUBORDINATES_ROUTE,
  TERMS_AND_CONDITIONS_ROUTE,
} from './routes';
import MyGemVaultSvg from '../assets/img/my-gem-vault.svg';
import MyGemFavSvg from '../assets/img/folder-favourite.svg';
import PorolisGemBankSvg from '../assets/img/bank.svg';
import SuboordinatesSvg from '../assets/img/subordinates-new.svg';
import SubordinatesSelected from '../assets/img/subordinates-selected.svg';
import MyGemVaultBoldSvg from '../assets/img/sidebar/my-gem-vault-bold.svg';
import UploadAPhotoSvg from '../assets/img/sidebar/upload-icon-black.svg';
import TermsSvg from '../assets/img/sidebar/terms.svg';
import SubscriptionSvg from '../assets/img/sidebar/manage-subscription.svg';
import MyGemVaultHoverSvg from '../assets/img/sidebar/my-gem-vault-hover.svg';

export enum ActionType {
  UPLOAD_PHOTO = 'upload_photo',
  PAGE_NAVIGATION = 'page_navigation',
  NONE = 'none',
}
type Icon = {
  selected: string;
  unselected: string;
};

export type SidebarOptionType = {
  name: SidebarOption;
  path?: string;
  icon: Icon;
  roles: Roles[];
  actionType: ActionType;
  subPath?: SidebarOptionType[];
  disabled?: boolean;
};

export const SIDEBAR_OPTIONS: SidebarOptionType[] = [
  {
    name: SidebarOption.MY_GEM_VAULT,
    path: MY_GEM_VAULT_ROUTE,
    actionType: ActionType.NONE,
    icon: { selected: MyGemVaultBoldSvg, unselected: MyGemVaultSvg },
    roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
    subPath: [
      {
        name: SidebarOption.VIEW_MY_GEM_VALUT,
        path: MY_GEM_VAULT_ROUTE,
        actionType: ActionType.PAGE_NAVIGATION,
        icon: { selected: MyGemVaultHoverSvg, unselected: MyGemVaultSvg },
        roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
        subPath: [],
      },
      {
        name: SidebarOption.UPLOAD_A_PHOTO,
        icon: { selected: UploadAPhotoSvg, unselected: UploadAPhotoSvg },
        roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN],
        subPath: [],
        actionType: ActionType.UPLOAD_PHOTO,
      },
    ],
  },
  {
    name: SidebarOption.MY_GEM_FAV,
    path: MY_GEM_FAV_ROUTE,
    actionType: ActionType.PAGE_NAVIGATION,
    icon: { selected: MyGemFavSvg, unselected: MyGemFavSvg },
    roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
  },
  {
    name: SidebarOption.POROLIS_GEM_BANK,
    path: POROLIS_GEM_BANK_ROUTE,
    actionType: ActionType.PAGE_NAVIGATION,
    icon: { selected: PorolisGemBankSvg, unselected: PorolisGemBankSvg },
    roles: [Roles.SAAS_ADMIN, Roles.SAAS_USER, Roles.NCC_USER],
  },
  {
    name: SidebarOption.PAYMENTS,
    path: PAYMENTS_ROUTE,
    actionType: ActionType.PAGE_NAVIGATION,
    icon: { selected: PaymentsLinear, unselected: PaymentsLinear },
    roles: [Roles.SAAS_ADMIN],
    disabled: true,
  },
  {
    name: SidebarOption.SUBORDINATES,
    path: SUBORDINATES_ROUTE,
    actionType: ActionType.PAGE_NAVIGATION,
    icon: { selected: SubordinatesSelected, unselected: SuboordinatesSvg },
    roles: [Roles.SAAS_ADMIN],
  },
  {
    name: SidebarOption.SETTINGS,
    path: SETTINGS_ROUTE,
    actionType: ActionType.PAGE_NAVIGATION,
    icon: { selected: SettingsSvg, unselected: SettingsSvg },
    roles: [Roles.SAAS_ADMIN, Roles.SAAS_USER, Roles.NCC_USER],
    subPath: [
      {
        name: SidebarOption.TERMS_AND_CONDITIONS,
        actionType: ActionType.PAGE_NAVIGATION,
        icon: { selected: TermsSvg, unselected: TermsSvg },
        roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
        subPath: [],
        path: TERMS_AND_CONDITIONS_ROUTE,
      },
      {
        name: SidebarOption.MANAGE_SUBSCRIPTION,
        path: MANAGE_SUBSCRIPTION,
        actionType: ActionType.PAGE_NAVIGATION,
        icon: { selected: SubscriptionSvg, unselected: SubscriptionSvg },
        roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
        subPath: [],
        disabled: true,
      },
    ],
  },
];
